import { client, appclient } from "./index";


export const getDeals = (token, deal_id, country) => appclient.get(`get_deal?deal_id=${deal_id}&country=${country}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getEquipmentNumbers = (token, RsNumber, basin, country) => appclient.get(`get_bc_resource?resource_group_no=${!RsNumber ? ' ' : RsNumber}&basin=${basin}&country=${country}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getEqipment = (token, id, country, RequestType) => appclient.get(`get_equipments?id=${id}&country=${country}&RequestType=${RequestType}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getReEqipment = (token, id, country, RequestType, ResupplyDetailsID) => appclient.get(`get_equipments?id=${id}&country=${country}&RequestType=${RequestType}&ResupplyDetailsID=${ResupplyDetailsID}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getBasins = (token, RsNumber, country) => appclient.get(`get_basin?resource_group_no=${RsNumber}&country=${country}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getReBasins = (token, RsNumber, country, jobId) => appclient.get(`get_basin_resupply?resource_group_no=${RsNumber}&country=${country}&Job_ID=${jobId}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getBasinsOptions = (token, country) => appclient.get(`get_basin?country=${country}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getReBasinsOptions = (token, country, jobId) => appclient.get(`get_basin_resupply?country=${country}&Job_ID=${jobId}`, { headers: { "Authorization": `Bearer ${token}` } });
export const saveItems = (token, payload, country) => appclient.post(`save_items?country=${country}`, payload, { headers: { "Authorization": `Bearer ${token}` } });
export const getSummary = (token, id, basin) => appclient.get(`get_asset_summary?job_id=${id}&selected_basin=${basin}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getReSupplySummary = (token, id, basin, RequestType, ResupplyDetailsID) => appclient.get(`get_asset_summary?job_id=${id}&selected_basin=${basin}&RequestType=${RequestType}&ResupplyDetailsID=${ResupplyDetailsID}`, { headers: { "Authorization": `Bearer ${token}` } });
export const saveReSummary = (token, payload, country, job_details_id, is_deployed, RequestType, ResupplyDetailsID) => appclient.post(`summary/save?country=${country}&job_details_id=${job_details_id}&is_deployed=${is_deployed}&RequestType=${RequestType}&ResupplyDetailsID=${ResupplyDetailsID}`, payload, { headers: { "Authorization": `Bearer ${token}` } });
export const saveSummary = (token, payload, country, job_details_id, is_deployed) => appclient.post(`summary/save?country=${country}&job_details_id=${job_details_id}&is_deployed=${is_deployed}`, payload, { headers: { "Authorization": `Bearer ${token}` } });
export const deleteEquipment = (token, payload) => {
  return appclient.post(`delete_equipments?equipment_id=${payload.equipment_id}`, {}, { headers: { "Authorization": `Bearer ${token}` } });
}
export const getSummaryBasinOptions = (token, id, country) => appclient.get(`get_deployment_summary?job_id=${id}&country=${country}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getReSupplySummaryBasinOptions = (token, id, country, RequestType, ResupplyDetailsID) => appclient.get(`get_deployment_summary?job_id=${id}&country=${country}&RequestType=${RequestType}&ResupplyDetailsID=${ResupplyDetailsID}`, { headers: { "Authorization": `Bearer ${token}` } });



export const getHose = (token, id, country, RequestType, ResupplyDetailsID) => {
  const params = { id, country, RequestType, ResupplyDetailsID };
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = queryString ? `get_hose?${queryString}` : 'get_hose';

  return appclient.get(url, {
    headers: { "Authorization": `Bearer ${token}` },
  });
};
;

export const getItems = (token, id, country, RequestType, ResupplyDetailsID) => {
  const params = { id, country, RequestType, ResupplyDetailsID };
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = queryString ? `get_items?${queryString}` : 'get_items';

  return appclient.get(url, {
    headers: { "Authorization": `Bearer ${token}` },
  });
};

export const getHoseType = (token, country) =>
  appclient.get(`get_hose_types?country=${country}`, {
    headers: { "Authorization": `Bearer ${token}` },
  });
export const getFittinngType = (token, country) =>
  appclient.get(`get_hose_fitting_types?country=${country}`, {
    headers: { "Authorization": `Bearer ${token}` },
  });
export const getSuppliedChainOptions = (token, country) =>
  appclient.get(`get_asset_type?country=${country}`, {
    headers: { "Authorization": `Bearer ${token}` },
  });
export const getPrimaryBasinOptions = (token) =>
  appclient.get(`primary_basin`, {
    headers: { "Authorization": `Bearer ${token}` },
  })
export const saveHose = (token, payload, country) =>
  appclient.post(`save_hose?country=${country}`, payload, {
    headers: { "Authorization": `Bearer ${token}` },
  });

export const saveEqipment = (token, payload, country) =>
  appclient.post(`save_equipment?country=${country}`, payload, {
    headers: { "Authorization": `Bearer ${token}` },
  });


export const getCustomPackage = (token, id, country, RequestType, ResupplyDetailsID) => {
  const params = { id, country, RequestType, ResupplyDetailsID };
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = queryString ? `get_custom_package?${queryString}` : 'get_custom_package';
  return appclient.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
};;

export const saveCustomPackageItems = (token, payload, country) =>
  appclient.post(
    `save_custom_package_items?country=${country}`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );


export const getHSE = (token, id, country, RequestType, ResupplyDetailsID) => {
  const params = { id, country, RequestType, ResupplyDetailsID };
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = queryString ? `get_hse?${queryString}` : 'get_hse';

  return appclient.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const saveHSE = (token, payload, country) =>
  appclient.post(
    `save_hse?country=${country}`, // endpoint path only
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const getLabItems = (token, job_id, country, RequestType, ResupplyDetailsID) => {
  const params = { id: job_id, country, RequestType, ResupplyDetailsID };
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = queryString ? `get_lab_equipment?${queryString}` : 'get_lab_equipment';

  return appclient.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const saveLabItems = (token, payload, country) =>
  appclient.post(
    `save_lab_equipment?country=${country}`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const get3rdParty = (token, id, country, ResupplyDetailsID) => {
  const params = { id, country, ResupplyDetailsID };
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
  const url = queryString ? `get_third_party?${queryString}` : 'get_third_party';
  return appclient.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const save3rdParty = (token, payload, country) =>
  appclient.post(`save_third_party_items?country=${country}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });


export const saveJob = (token, payload, country) =>
  appclient.post(`save_job_details?country=${country}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });


export const getStats = (token) =>
  appclient.get(`get_dashboard_summary`,
    { headers: { "Authorization": `Bearer ${token}` } });

export const getFilterOptions = (token) =>
  appclient.get(`get_filtering_options`,
    { headers: { "Authorization": `Bearer ${token}` } });

export const getJobs = (token, payload) =>
  appclient.post(`get_paginated_table_data`, payload,
    { headers: { "Authorization": `Bearer ${token}` } });


export const exportJobsData = (token, payload) =>
  appclient.get(`download-csv?location=${payload.location}&customer=${payload.customer}&job_type=${payload.job_type}&sales_name=${payload.sales_name}`,
    { headers: { "Authorization": `Bearer ${token}` } });

export const getAllStatus = (token) =>
  appclient.get(`get_status`,
    { headers: { "Authorization": `Bearer ${token}` } });

export const postReSupplyRequest = (payload, token) =>
  appclient.post(`create_request`, payload,
    { headers: { "Authorization": `Bearer ${token}` } });


export const getHistoricalData = (token, JobDetails_ID) =>
  appclient.get(`History_requests_info?JobDetails_ID=${JobDetails_ID}`, {
    headers: { "Authorization": `Bearer ${token}` },
  });

export const getRequestId = (token, jobId) =>
  appclient.get(`Active_requests?JobDetails_ID=${jobId}`,
    { headers: { "Authorization": `Bearer ${token}` } });